/* ============================================================================
   Zurueck-Knopf auf der Produktseite + gemerkte Scrollposition
   ZURUECK AUF JEDER SEITE (14.09.2026)
   ----------------------------------------------------------------------------
   Der Weg zurueck soll dort landen, wo man losgegangen ist - ueber den Knopf auf der
   Seite, die Zurueck-Taste oder die Wischgeste von links nach rechts auf dem Handy.

   Was die bisherige Fassung (unten, STILLGELEGT) nicht abdeckte:
     1. Sie merkte sich die Stelle NUR auf Seiten mit Produktraster (#product-grid).
        Rezepte/Neues laden ebenfalls nach ("Mehr laden", #blog-grid) - dort fehlten die
        nachgeladenen Beitraege beim Zurueckkommen, und alle uebrigen Seiten blieben dem
        Browser ueberlassen.
     2. Sie sprang auf eine PIXELZAHL. Aendert sich die Hoehe ueber der Stelle nach dem
        Aufbau noch (Bilder, Schriften, eingeklappte Kopfzeile, Hinweisbalken), landet
        eine Pixelzahl daneben - auf dem Handy mit seinen hohen, gestapelten Bloecken
        besonders deutlich.
     3. Nach 500ms war Schluss. Auf langsamen Verbindungen laeuft das Nachladen der
        Bilder laenger.

   Jetzt:
     - Gemerkt wird auf JEDER Seite: Pixelposition, Zahl der geladenen Kacheln und ein
       ANKER - das Element, das oben im Fenster stand (Kachel im Raster oder Abschnitt),
       samt seinem Abstand zur Fensteroberkante.
     - Beim Zurueckkommen werden fehlende Portionen nachgeladen (Shop, Suche, Blog), dann
       wird so gescrollt, dass der Anker wieder an derselben Stelle steht.
     - Verschiebt sich die Seite danach noch, wird bis zu HALTEZEIT nachgefuehrt - aber
       nur, solange der Nutzer nicht selbst scrollt oder tippt.
     - Kommt die Seite aus dem Vor-/Zurueck-Speicher des Browsers (bfcache), stellt der
       Browser alles selbst her. Nur falls sie dabei merklich verrutscht ist, wird einmal
       auf den Anker korrigiert.
   ========================================================================== */
(function () {
  'use strict';

  const VORSATZ = 'dgl:pos:';
  const HALTBARKEIT = 60 * 60 * 1000; // eine Stunde
  const HALTEZEIT = 2500;             // so lange wird nach dem Zurueckkommen nachgefuehrt

  const schluessel = () => VORSATZ + location.pathname + location.search;
  const gitter = () => document.querySelector('#product-grid, #blog-grid');
  const kachelnIn = (g) => (g.id === 'blog-grid' ? g.children.length : g.querySelectorAll('.grid__item').length);

  const lesen = () => {
    try {
      return JSON.parse(sessionStorage.getItem(schluessel()) || 'null');
    } catch (e) {
      return null;
    }
  };

  /* Zurueck/Vorwaerts ODER Neuladen - beide Male kommt der Nutzer an eine Stelle
     zurueck, die er schon kannte.

     DAS NEULADEN KAM ERST AM 28.09.2026 DAZU, und es war die eigentliche Ursache der
     gemeldeten Fehler. Belegt durch die Messsonde im Browser des Nutzers:

         Navigation   reload   Weg: untaetig (nicht zustaendig)
         gemerkt      Lage 15381   Kacheln 144   Hoehe 17239
         Lage         2159        Schreibungen 0

     Was dabei passiert: Der Browser stellt beim Neuladen die Scrollposition SELBST
     wieder her - er versucht 15381. Das frische Dokument hat aber nur die erste
     Portion (18 Kacheln), seine ganze Strecke betraegt rund 2159 Pixel. Der Browser
     KAPPT den Wert auf das Maximum: Man landet punktgenau am SEITENENDE.
     Genau so wurde es beschrieben - "erstmal nichts, dann landet man am Ende der
     Seite wo man war". Unser Skript schaute dabei zu, weil es sich nur fuer
     back_forward zustaendig fuehlte.

     Deshalb gilt es jetzt auch beim Neuladen: Platz reservieren, hinspringen,
     Kacheln unsichtbar nachliefern - derselbe Weg wie beim Zurueckgehen.
     (Pruefliste "History and scroll restoration contracts", Punkt 5: erst schreiben,
     wenn das Ziel ueberhaupt darstellbar ist.) */
  const istZurueckNavigation = () => {
    try {
      const eintrag = performance.getEntriesByType('navigation')[0];
      return !!eintrag && (eintrag.type === 'back_forward' || eintrag.type === 'reload');
    } catch (e) {
      return false;
    }
  };

  /* Scrollwiederherstellung des Browsers fruehzeitig abschalten - vor dem ersten Bild,
     sonst springt die Seite erst an eine falsche Stelle. Nur, wenn wirklich etwas
     wiederherzustellen ist. */
  /* Nennt die Adresse selbst eine Seite (?page=N), ist nichts nachzuladen:
     Der Server liefert dann genau die Kacheln, die man zuletzt gesehen hat, und die
     Scrollwiederherstellung des BROWSERS trifft von allein. Unser Nachbau wuerde dort
     nur stoeren - er hat sich die Kachelzahl ueber ALLE Portionen gemerkt, wuerde sie
     erneut anhaengen und den sichtbaren Aufbau ausloesen, den wir gerade loswerden.
     Gesetzt wird die Seite in assets/load-more.js und assets/blog-neues.js
     (replaceState, Vorbild clearspring.co.uk - Begruendung dort). */
  const seiteAusAdresse = () => {
    let roh = null;
    try {
      roh = new URLSearchParams(location.search).get('page');
    } catch (e) {
      const t = /[?&]page=(\d+)/.exec(location.search);
      roh = t && t[1];
    }
    const n = parseInt(roh, 10);
    return Number.isFinite(n) && n > 1 ? n : 0;
  };

  /* Mit welcher Seite hat dieses Dokument ANGEFANGEN?
     Wird beim Laden des Skripts gelesen, also bevor load-more.js per replaceState
     hochzaehlt. Ohne page-Angabe ist es Seite 1.

     WARUM DAS GEBRAUCHT WIRD (Fehler vom 28.09.2026, vom Nutzer gefunden):
     vorseitenHolen() nahm an, im Dokument stuenden die Seiten 1..N - was nur stimmt,
     wenn man bei Seite 1 eingestiegen ist. Ruft man dagegen ?page=10 direkt auf und
     drueckt einmal "Mehr laden", steht in der Adresse ?page=11, im Dokument stehen
     aber nur die Seiten 10 und 11. Beim Zurueckkommen haette das Skript die Seiten
     1 bis 10 davorgehaengt - ein viel hoeheres Dokument als das, in dem die gemerkte
     Pixelposition gemessen wurde. Man waere weit daneben gelandet.
     Mit der Einstiegsseite wird genau der Bereich nachgeliefert, der wirklich fehlt. */
  const startSeite = seiteAusAdresse() || 1;

  const gemerkt = lesen();
  const zustaendig = istZurueckNavigation() && !!gemerkt && gemerkt.y > 0
    && (Date.now() - gemerkt.zeit) < HALTBARKEIT
    && !seiteAusAdresse();
  if (zustaendig && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  /* ---- Anker: was stand oben im Fenster? -------------------------------------- */
  const kopfUnten = () => {
    const k = document.querySelector('.section-header');
    const b = k && k.getBoundingClientRect();
    return b && b.bottom > 0 ? b.bottom : 0;
  };

  const ankerFinden = () => {
    const y = Math.min(window.innerHeight - 1, kopfUnten() + 12);
    const x = Math.round(window.innerWidth / 2);
    let el = document.elementFromPoint(x, y);
    if (!el) return null;
    const g = gitter();
    const kachel = g && el.closest && el.closest('#product-grid > *, #blog-grid > *');
    if (kachel && g.contains(kachel)) {
      return { art: 'kachel', index: Array.prototype.indexOf.call(g.children, kachel), abstand: Math.round(kachel.getBoundingClientRect().top) };
    }
    const abschnitt = el.closest && el.closest('.shopify-section[id]');
    if (abschnitt) {
      return { art: 'abschnitt', id: abschnitt.id, abstand: Math.round(abschnitt.getBoundingClientRect().top) };
    }
    return null;
  };

  const ankerElement = (anker) => {
    if (!anker) return null;
    if (anker.art === 'kachel') {
      const g = gitter();
      return (g && g.children[anker.index]) || null;
    }
    if (anker.art === 'abschnitt') return document.getElementById(anker.id);
    return null;
  };

  // Zielposition: ueber den Anker, sonst die gemerkte Pixelzahl.
  const zielY = (stand) => {
    const el = ankerElement(stand.anker);
    if (el && el.getBoundingClientRect().height > 0) {
      return Math.max(0, Math.round(window.scrollY + el.getBoundingClientRect().top - stand.anker.abstand));
    }
    return stand.y;
  };

  /* ---- Merken ------------------------------------------------------------- */
  const merken = () => {
    const g = gitter();
    try {
      sessionStorage.setItem(schluessel(), JSON.stringify({
        y: Math.round(window.scrollY),
        kacheln: g ? kachelnIn(g) : 0,
        // Hoehe des Kachelblocks. Beim Zurueckkommen wird genau dieser Platz sofort
        // reserviert, damit die gemerkte Pixelposition ueberhaupt erreichbar ist,
        // BEVOR die fehlenden Seiten eingetroffen sind (siehe vorseitenHolen).
        gitterHoehe: g ? Math.round(g.getBoundingClientRect().height) : 0,
        // Erste Seite, die in diesem Dokument steht (siehe startSeite oben).
        vonSeite: startSeite,
        anker: ankerFinden(),
        zeit: Date.now()
      }));
    } catch (e) {
      /* privater Modus o.ae. - dann eben ohne Gedaechtnis */
    }
  };

  // pagehide deckt Navigation, Tab schliessen und den Wechsel in den bfcache ab -
  // zuverlaessiger als beforeunload, das auf iOS haeufig gar nicht feuert.
  window.addEventListener('pagehide', merken);
  // Zusaetzlich beim Tippen auf einen Link (Erfassungsphase): Die Stelle steht dann,
  // bevor irgendetwas am Layout passiert.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href]')) merken();
  }, true);

  /* ---- Zurueck-Knopf der Produktseite -------------------------------------
     Echter Link auf die Kollektion als Rueckfall (direkt geoeffnet, kein Verlauf);
     mit eigener Vorgeschichte wird daraus ein echtes Zurueck. */
  document.addEventListener('click', function (e) {
    const knopf = e.target.closest && e.target.closest('[data-product-back]');
    if (!knopf) return;
    let vonHier = false;
    try {
      vonHier = !!document.referrer &&
        new URL(document.referrer).origin === location.origin;
    } catch (err) {
      vonHier = false;
    }
    if (vonHier && history.length > 1) {
      e.preventDefault();
      history.back();
    }
  });

  /* ---- Nachladen (Shop/Suche: #product-grid, Blog: #blog-grid) -------------
     GEMESSEN am 28.09.2026 (Chrome, Shopseite mit 162 Kacheln = 9 Portionen), Zeit vom
     Zurueckkommen bis die gemerkte Stelle wieder stand:

        Live, aus dem Vor-/Zurueck-Speicher ..........    8 ms
        Live, ohne diesen Speicher ................... 959 ms
        Dev-Server .................................. 2765 ms

     Der Dev-Server kann den Vor-/Zurueck-Speicher des Browsers nicht nutzen - seine
     Hot-Reload-Verbindung schliesst die Seite davon aus. Dort ist also IMMER der lange
     Weg zu sehen. Live tritt er nur auf, wenn der Speicher nicht zieht: Seite neu
     geladen, in neuem Tab geoeffnet, zu lange her, zu viele Seiten dazwischen.

     Von den 2765 ms waren rund 2265 ms reines Warten auf acht Anfragen, die
     NACHEINANDER liefen - jede rund 280 ms. Der Grund war die Bauart, nicht das Netz:
     Die Adresse der naechsten Portion stand erst in der Antwort der vorigen
     (data-next-url), jede musste also auf ihre Vorgaengerin warten.

     Und weil wiederherstellen() auf das Nachladen WARTET, bevor es scrollt, stand die
     Seite die ganze Zeit oben und sprang erst ganz am Ende an ihre Stelle.

     JETZT: Die Adressen werden vorher ausgerechnet. Sie unterscheiden sich nur im
     Parameter page, und wie viele Portionen fehlen, sagt die gemerkte Kachelzahl geteilt
     durch die Groesse der ersten Portion. Damit lassen sich alle gleichzeitig holen.
     Als Grundlage dient die vorhandene data-next-url und KEINE selbst gebaute Adresse -
     so bleiben Filter, Sortierung und Suchbegriff erhalten.

     Eingehaengt wird in EINEM Rutsch ueber ein DocumentFragment. Vorher wanderte jede
     Kachel einzeln in die Seite, und weil grid-background.js den ganzen <body> beobachtet,
     loeste jede davon eine komplette Neuzeichnung des Rasters aus (18-21 ms, siehe
     CLAUDE.md "Keine Dauerlast erzeugen"). Bei 144 nachgeladenen Kacheln war das der
     zweite Kostenblock.

     RUECKFALL: Geht etwas nicht auf - keine erste Portion messbar, keine data-next-url,
     eine Anfrage scheitert, oder am Ende fehlen trotzdem Kacheln -, laeuft
     nachladenNacheinander() weiter: die unveraenderte alte Fassung. Sie ist bewusst
     nicht stillgelegt, sondern bleibt der benutzte Sicherungsweg. */
  const nachladenNacheinander = async (g, ziel) => {
    const blog = g.id === 'blog-grid';
    let schutz = 30; // Obergrenze gegen Endlosschleifen
    while (kachelnIn(g) < ziel && schutz-- > 0) {
      const knopf = document.querySelector(blog ? '.blog-load-more' : '.collection-load-more');
      const naechste = knopf && knopf.getAttribute('data-next-url');
      if (!naechste) return;
      let doc;
      try {
        const antwort = await fetch(naechste);
        doc = new DOMParser().parseFromString(await antwort.text(), 'text/html');
      } catch (e) {
        return;
      }
      const neu = doc.querySelector(blog ? '#blog-grid' : '#product-grid');
      if (!neu) return;
      if (blog) {
        Array.prototype.forEach.call(neu.children, function (el) { g.appendChild(document.importNode(el, true)); });
      } else {
        neu.querySelectorAll('.grid__item').forEach(function (el) { g.appendChild(el); });
      }
      const neuerKnopf = doc.querySelector(blog ? '.blog-load-more' : '.collection-load-more');
      const neueUrl = neuerKnopf && neuerKnopf.getAttribute('data-next-url');
      if (neueUrl) {
        knopf.setAttribute('data-next-url', neueUrl);
      } else if (blog) {
        const wrap = knopf.closest('.blog-load-more-wrap');
        (wrap || knopf).remove();
        return;
      } else {
        // Shop: nur den Knopf ausblenden, der Wrapper haelt den Abstand zur Fusszeile.
        knopf.style.display = 'none';
        return;
      }
    }
  };

  const nachladen = async (g, ziel) => {
    const blog = g.id === 'blog-grid';
    const knopf = document.querySelector(blog ? '.blog-load-more' : '.collection-load-more');
    const naechste = knopf && knopf.getAttribute('data-next-url');
    const proSeite = kachelnIn(g);            // Groesse der ersten Portion
    if (!knopf || !naechste || proSeite < 1 || ziel <= proSeite) {
      return nachladenNacheinander(g, ziel);
    }

    // Wie viele Seiten insgesamt? Die erste steht schon, geholt werden 2 .. seiten.
    // Die Obergrenze 31 entspricht dem schutz-Zaehler der alten Schleife.
    const seiten = Math.min(31, Math.ceil(ziel / proSeite));
    let adressen = [];
    try {
      const basis = new URL(naechste, location.href);
      for (let n = 2; n <= seiten; n++) {
        basis.searchParams.set('page', String(n));
        adressen.push(basis.pathname + basis.search);
      }
    } catch (e) {
      return nachladenNacheinander(g, ziel);
    }
    if (!adressen.length) return nachladenNacheinander(g, ziel);

    let seitenDocs;
    try {
      // Alle Portionen gleichzeitig. Promise.all behaelt die REIHENFOLGE der Eingabe bei -
      // die Kacheln landen also in derselben Folge wie beim Klicken auf "Mehr laden",
      // gleich welche Antwort zuerst eintrifft.
      seitenDocs = await Promise.all(adressen.map(async (u) => {
        const antwort = await fetch(u);
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return new DOMParser().parseFromString(await antwort.text(), 'text/html');
      }));
    } catch (e) {
      return nachladenNacheinander(g, ziel);
    }

    // Ein einziges Einhaengen fuer alle Portionen.
    const stapel = document.createDocumentFragment();
    let letztesDoc = null;
    seitenDocs.forEach(function (doc) {
      const neu = doc.querySelector(blog ? '#blog-grid' : '#product-grid');
      if (!neu) return;
      letztesDoc = doc;
      if (blog) {
        Array.prototype.forEach.call(neu.children, function (el) { stapel.appendChild(document.importNode(el, true)); });
      } else {
        neu.querySelectorAll('.grid__item').forEach(function (el) { stapel.appendChild(el); });
      }
    });
    g.appendChild(stapel);

    // Den Knopf auf den Stand nach der letzten geholten Portion bringen.
    if (letztesDoc) {
      const neuerKnopf = letztesDoc.querySelector(blog ? '.blog-load-more' : '.collection-load-more');
      const neueUrl = neuerKnopf && neuerKnopf.getAttribute('data-next-url');
      if (neueUrl) {
        knopf.setAttribute('data-next-url', neueUrl);
      } else if (blog) {
        const wrap = knopf.closest('.blog-load-more-wrap');
        (wrap || knopf).remove();
      } else {
        // Shop: nur den Knopf ausblenden, der Wrapper haelt den Abstand zur Fusszeile.
        knopf.style.display = 'none';
      }
    }

    // Kam weniger an als erwartet (andere Portionsgroesse, Filter, entfernte Produkte),
    // holt die alte Schleife den Rest nach.
    if (kachelnIn(g) < ziel) return nachladenNacheinander(g, ziel);
  };

  /* ---- Die Seiten OBERHALB unsichtbar nachliefern (28.09.2026) -------------
     Ausgangslage: Seit load-more.js die geladene Seite in die Adresse schreibt
     (Vorbild clearspring.co.uk, Begruendung dort), liefert der Server beim
     Zurueckkommen genau die Seite, auf der man war - Seite N mit ihren 18 Kacheln.
     Das ist ruhig und ohne sichtbaren Aufbau, hat aber zwei Luecken:

       1. Die gemerkte Pixelposition stammt aus dem GESTAPELTEN Dokument (alle
          Seiten 1..N untereinander). Seite N allein ist viel kuerzer, der Browser
          klemmt die Position ans Ende. Gemessen: 7816 gemerkt, 2236 erreicht.
       2. Nach oben kommt man nicht mehr - die Kacheln der Seiten 1..N-1 fehlen.
          Clearspring loest das mit einer sichtbaren Seitenleiste. Hier ausdruecklich
          NICHT gewuenscht: Die Seiten sollen im Hintergrund gerechnet werden.

     LOESUNG, in dieser Reihenfolge - die Reihenfolge ist der ganze Punkt:
       a) Der Kachelblock bekommt SOFORT seine gemerkte Hoehe als min-height.
          Damit ist das Dokument so hoch wie vorher, und die gemerkte Position ist
          ueberhaupt erreichbar.
       b) Es wird sofort dorthin gesprungen - noch bevor irgendetwas geladen ist.
       c) Die Seiten 1..N-1 werden GLEICHZEITIG geholt (nicht nacheinander: das war
          der alte Fehler, acht Anfragen in Reihe = 2265 ms Wartezeit) und in EINEM
          Zug vor die vorhandenen Kacheln gehaengt.
       d) Erst danach faellt die Reservierung weg.

     Weil die Kacheln VOR die vorhandenen wandern und die reservierte Hoehe genau
     stimmt, bleibt die Seite dabei stehen: Was man sieht, rutscht nicht weg. Der
     Sprung aus (b) ist die einzige Bewegung.

     Faellt irgendetwas aus (keine Kachelzahl gemerkt, eine Anfrage scheitert), bleibt
     es bei Seite N - also bei dem Zustand, der auch ohne diese Funktion herauskaeme.
     Schlechter als vorher wird es nie. */
  const vorseitenHolen = async (seite) => {
    const g = gitter();
    if (!g || g.id === 'blog-grid') return false;     // nur Shop/Suche
    if (!gemerkt || !gemerkt.y || !gemerkt.gitterHoehe) return false;
    if (!istZurueckNavigation()) return false;
    if ((Date.now() - gemerkt.zeit) >= HALTBARKEIT) return false;

    /* Ab welcher Seite muss nachgeliefert werden? Nicht stur ab 1, sondern ab der
       Seite, mit der das Dokument beim Weggehen angefangen hatte (siehe startSeite). */
    const von = Math.min(seite, Math.max(1, parseInt(gemerkt.vonSeite, 10) || 1));
    if (von >= seite) return false;      // nichts nachzuliefern

    /* Hoehe EINER Seite - gemessen, solange nur Seite N im Gitter steht.
       Sie ist der Umrechnungsfaktor fuer den Notfall weiter unten. */
    const einSeitenHoehe = g.getBoundingClientRect().height;

    // a) Platz reservieren, b) hinspringen - beides ohne eine einzige Anfrage.
    const hoeheVorher = g.style.minHeight;
    g.style.minHeight = gemerkt.gitterHoehe + 'px';
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, gemerkt.y);

    /* Landet die Seite am Ende hier, ist die Wiederherstellung fertig - egal wie
       viele Seiten wirklich angekommen sind. WICHTIG: Diese Funktion MUSS die
       Position setzen und scrollRestoration zuruecknehmen, auch wenn alles
       schiefgeht. Genau das fehlte in der ersten Fassung (28.09.2026): Sie sprang
       zuerst an die gemerkte Stelle, liess dann bei der kleinsten Stoerung alles
       fallen - und der Nutzer stand irgendwo, meist am Seitenende.
         eingefuegt = Zahl der Seiten, die tatsaechlich VOR Seite N stehen. */
    const abschliessen = (eingefuegt) => {
      g.style.minHeight = hoeheVorher;
      let y;
      if (eingefuegt >= seite - von) {
        // Vollstaendig: der Anker trifft genau. Feinschliff fuer den Fall, dass
        // eine Kachelreihe anders umbricht (schmaleres Fenster, fehlendes Produkt).
        y = zielY(gemerkt);
      } else {
        /* Unvollstaendig: Ueber der Kachel, die man ansah, fehlen
           (seite - 1 - eingefuegt) Seiten. Um genau diese Hoehe ist alles nach oben
           gerutscht - also wird die gemerkte Position um denselben Betrag verringert.
           Man landet dadurch bei DENSELBEN Produkten, nur in einer kuerzeren Seite. */
        const fehlend = (seite - von - eingefuegt) * einSeitenHoehe;
        y = Math.max(0, Math.round(gemerkt.y - fehlend));
      }
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
      return eingefuegt >= seite - von;
    };

    let adressen = [];
    try {
      const basis = new URL(location.href);
      for (let n = von; n < seite; n++) {
        if (n === 1) basis.searchParams.delete('page');
        else basis.searchParams.set('page', String(n));
        adressen.push(basis.pathname + basis.search);
      }
    } catch (e) {
      return abschliessen(0);
    }

    /* Hoechstens GLEICHZEITIG Anfragen auf einmal.
       Gemessen am 28.09.2026: Acht gleichzeitige Anfragen an den Dev-Server
       brachten eine mit HTTP 502 zurueck, eine tiefe Seite auf dem zweiten Server
       sogar 401 - der Server bricht unter dem Schwall ein. Drei auf einmal sind
       immer noch deutlich schneller als nacheinander (das waren 2265 ms) und
       schonen die Gegenstelle. Ein Wiederholversuch je Seite faengt den Rest ab. */
    const GLEICHZEITIG = 3;
    const docs = new Array(adressen.length).fill(null);
    const laden = async (u) => {
      for (let versuch = 0; versuch < 2; versuch++) {
        try {
          const antwort = await fetch(u);
          if (antwort.ok) return new DOMParser().parseFromString(await antwort.text(), 'text/html');
        } catch (e) {
          /* Netzfehler - der zweite Versuch bekommt seine Chance. */
        }
      }
      return null;
    };
    let naechster = 0;
    const arbeiter = async () => {
      while (naechster < adressen.length) {
        const i = naechster++;
        docs[i] = await laden(adressen[i]);
      }
    };
    await Promise.all(Array.from({ length: Math.min(GLEICHZEITIG, adressen.length) }, arbeiter));

    /* Nur der LUECKENLOSE Anfang wird eingehaengt. Fehlt Seite 3, duerfen 4 und 5
       nicht trotzdem hinein - sie saessen sonst an der Stelle von 3, und alles
       darunter waere um eine Seitenhoehe verschoben. Lieber weniger Kacheln als
       eine falsche Reihenfolge. */
    const stapel = document.createDocumentFragment();
    let eingefuegt = 0;
    for (let i = 0; i < docs.length; i++) {
      if (!docs[i]) break;
      const neu = docs[i].querySelector('#product-grid');
      if (!neu) break;
      const kacheln = neu.querySelectorAll('.grid__item');
      if (!kacheln.length) break;
      kacheln.forEach(function (el) { stapel.appendChild(el); });
      eingefuegt++;
    }
    if (stapel.childNodes.length) g.insertBefore(stapel, g.firstChild);

    // d) Reservierung weg, Position setzen - in jedem Fall.
    return abschliessen(eingefuegt);
  };

  /* ===== SCROLL-SONDE - abschaltbare Messanzeige (28.09.2026) =====
     Kennung zum Suchen: SCROLL-SONDE.
     Zeigt genau die Angaben, die die Pruefliste "History and scroll restoration
     contracts" unter "Quick probes" verlangt: Adresse, Eintragskennung, Art der
     Navigation, Besitzer des Scrollens, gemerkte / geschriebene / endgueltige Lage
     und die maximal moegliche Strecke zum Zeitpunkt der Wiederherstellung. */
  /* STANDARDMAESSIG AUS. Einschalten fuer eine Sitzung, in der Konsole:
         sessionStorage.setItem('dgl:sonde', '1')
     und neu laden. Ausschalten mit removeItem. Solange sie aus ist, kehrt sonde()
     sofort zurueck - kein DOM-Zugriff, keine Neuzeichnung des Rasters
     (CLAUDE.md, "Keine Dauerlast erzeugen").

     SIE HAT SICH GELOHNT: Der Fehler vom 28.09.2026 war ueber Tage nicht zu finden,
     weil im Browser des Entwicklers immer die Rueckwaerts-Navigation gemessen wurde,
     der Nutzer aber NEU LUD. Sichtbar wurde es erst durch die Zeile
         Navigation   reload   Weg: untaetig (nicht zustaendig)
     aus dem Browser des Nutzers. */
  const SONDE_AN = (function () {
    try { return sessionStorage.getItem('dgl:sonde') === '1'; } catch (e) { return false; }
  })();
  const messwerte = {};
  const sonde = (neu) => {
    if (!SONDE_AN) return;
    Object.assign(messwerte, neu);
    let box = document.getElementById('scroll-sonde');
    if (!box) {
      if (!document.body) return;
      box = document.createElement('div');
      box.id = 'scroll-sonde';
      box.style.cssText = 'position:fixed;bottom:4px;left:4px;z-index:2147483647;background:#fff;' +
        'border:2px solid #99220A;color:#99220A;font:11px/1.45 monospace;padding:6px 8px;' +
        'white-space:pre;pointer-events:none;max-width:52vw';
      document.body.appendChild(box);
    }
    const z = [];
    z.push('SCROLL-SONDE   Stand 3 (mit Neuladen)');
    z.push('  Adresse      ' + location.pathname + location.search);
    z.push('  Eintrag      ' + schluessel());
    z.push('  Navigation   ' + (messwerte.navTyp || '?') + '   Weg: ' + (messwerte.weg || '?'));
    z.push('  gemerkt      Lage ' + (messwerte.gemerktY != null ? messwerte.gemerktY : '-') +
           '   Kacheln ' + (messwerte.gemerktKacheln != null ? messwerte.gemerktKacheln : '-') +
           '   Hoehe ' + (messwerte.gemerktHoehe != null ? messwerte.gemerktHoehe : '-'));
    z.push('  Kacheln jetzt ' + (messwerte.kachelnJetzt != null ? messwerte.kachelnJetzt : '-') +
           '   nachgeladen ' + (messwerte.geladen != null ? messwerte.geladen : '-') +
           '   Fehler ' + (messwerte.ladefehler != null ? messwerte.ladefehler : 0));
    z.push('  Ziel         ' + (messwerte.ziel != null ? messwerte.ziel : '-') +
           '   Strecke max ' + (messwerte.strecke != null ? messwerte.strecke : '-'));
    z.push('  Lage         ' + (messwerte.lage != null ? messwerte.lage : Math.round(window.scrollY)) +
           '   Schreibungen ' + (messwerte.schreibungen || 0) +
           '   zu kurz ' + (messwerte.gekappt || 0));
    if (messwerte.endLage != null) z.push('  ENDLAGE      ' + messwerte.endLage);
    box.textContent = z.join('\n');
  };
  /* ===== ENDE SCROLL-SONDE ===== */

  /* ---- Wiederherstellen --------------------------------------------------- */
  const wiederherstellen = async () => {
    /* Warum untaetig? Jede Bedingung einzeln, damit man es im Kasten ablesen kann. */
    const nav = (performance.getEntriesByType('navigation')[0] || {}).type;
    const gruende = [];
    if (!istZurueckNavigation()) gruende.push('nav=' + nav);
    if (!gemerkt) gruende.push('kein Eintrag');
    else if (!(gemerkt.y > 0)) gruende.push('Lage 0');
    else if (!((Date.now() - gemerkt.zeit) < HALTBARKEIT)) gruende.push('zu alt');
    if (seiteAusAdresse()) gruende.push('page in Adresse');
    sonde({ navTyp: nav,
            weg: zustaendig ? 'wiederherstellen' : ('untaetig: ' + (gruende.join(', ') || '?')),
            gemerktY: gemerkt && gemerkt.y, gemerktKacheln: gemerkt && gemerkt.kacheln,
            gemerktHoehe: gemerkt && gemerkt.gitterHoehe });
    if (!zustaendig) return;
    const g = gitter();
    sonde({ kachelnJetzt: g ? kachelnIn(g) : -1 });

    /* ---- Platz reservieren und SOFORT springen (28.09.2026) -----------------
       Das ist der eigentliche Gewinn, und er braucht keine Seitenzahl in der
       Adresse (siehe ADRESSE_MIT_SEITE in assets/load-more.js).

       Vorher wurde erst nachgeladen und danach gesprungen. Solange das lief, stand
       die Seite oben - gemessen auf dem Dev-Server 1017 ms, in denen Kachel um
       Kachel erschien und sich erst am Ende alles an seinen Platz schob.

       Jetzt bekommt der Kachelblock zuerst seine gemerkte Hoehe. Damit ist das
       Dokument so hoch wie beim Weggehen, die gemerkte Position ist ueberhaupt
       erreichbar, und es wird sofort dorthin gesprungen - ohne eine einzige
       Anfrage. Die Kacheln wandern danach in den reservierten Platz; weil dessen
       Hoehe stimmt, rutscht dabei nichts. */
    let reserviert = false;
    if (g && gemerkt.kacheln && gemerkt.gitterHoehe && gemerkt.kacheln > kachelnIn(g)) {
      g.style.minHeight = gemerkt.gitterHoehe + 'px';
      reserviert = true;
      window.scrollTo(0, gemerkt.y);
    }

    if (g && gemerkt.kacheln) await nachladen(g, gemerkt.kacheln);
    if (reserviert) g.style.minHeight = '';
    sonde({ geladen: g ? kachelnIn(g) : -1 });

    /* ---- Anspringen: EINE Schreibung, sobald das Ziel darstellbar ist -------
       Umgebaut am 28.09.2026 nach der Pruefliste "History and scroll restoration
       contracts", Punkte 5 und 6.

       VORHER stand hier eine Leiter fester Zeitpunkte (100, 250, 500, 900,
       1500 ms), dazu 'load', document.fonts.ready und ein ResizeObserver auf dem
       GANZEN <body> - jedes davon mit einer weiteren Schreibung. Bis zu zehn
       Schreibungen je Rueckkehr. Zwei Fehler:

         1. Feste Zeitpunkte ersetzen keine Bereitschaft. Sie sind geraten und
            haengen an Geraet und Netz (Pruefliste Punkt 6).
         2. Wiederholte Schreibungen kaempfen gegen die Scroll-Verankerung des
            Browsers und gegen den Nutzer. Daher kam der gemessene Ausreisser:
            41 px bei 512 ms, eingefangen erst bei 1165 ms.

       Und der entscheidende Punkt 5: Ein scrollTo auf eine Stelle, die die Seite
       noch gar nicht hergibt, wird vom Browser GEKAPPT - er landet am unteren
       Ende. Im Protokoll sieht das wie ein Erfolg aus, sichtbar ist "man landet
       am Ende der Seite". Genau dieses Bild wurde gemeldet.

       JETZT wird vor jeder Schreibung geprueft, ob die Strecke reicht
       (scrollHeight - innerHeight). Reicht sie nicht, wird NICHT geschrieben,
       sondern auf Hoehenwachstum gewartet - beobachtet wird nur der Kachelblock,
       nicht der ganze Body. Hoechstens SCHREIB_GRENZE Schreibungen, Ende bei
       eigener Eingabe oder nach HALTEZEIT. */
    const SCHREIB_GRENZE = 3;
    let aktiv = true;
    let schreibungen = 0;
    let gekappt = 0;

    const stopp = () => { aktiv = false; };
    // Sobald der Nutzer selbst scrollt oder tippt, hat er das Wort.
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (t) {
      window.addEventListener(t, stopp, { passive: true, once: true });
    });

    const strecke = () => document.documentElement.scrollHeight - window.innerHeight;

    let beobachter = null;
    const beenden = () => {
      aktiv = false;
      if (beobachter) { beobachter.disconnect(); beobachter = null; }
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
      sonde({ endLage: Math.round(window.scrollY), schreibungen: schreibungen, gekappt: gekappt });
    };

    const hin = function () {
      if (!aktiv) return;
      const y = zielY(gemerkt);
      const max = strecke();
      if (max + 2 < y) {
        // Punkt 5: Ziel noch nicht darstellbar - lieber gar nicht schreiben.
        gekappt++;
        sonde({ ziel: y, strecke: Math.round(max), gekappt: gekappt });
        return;
      }
      if (Math.abs(window.scrollY - y) > 1) {
        if (schreibungen >= SCHREIB_GRENZE) return;
        window.scrollTo(0, y);
        schreibungen++;
      }
      sonde({ ziel: y, strecke: Math.round(max), lage: Math.round(window.scrollY),
              schreibungen: schreibungen, gekappt: gekappt });
      if (Math.abs(window.scrollY - y) <= 1) {
        // Getroffen. Zwei Bilder Ruhe zur Kontrolle, dann Schluss.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!aktiv) return;
            const y2 = zielY(gemerkt);
            if (Math.abs(window.scrollY - y2) > 1 && schreibungen < SCHREIB_GRENZE) {
              window.scrollTo(0, y2); schreibungen++;
            }
            beenden();
          });
        });
      }
    };

    hin();
    /* Echte Bereitschaftssignale statt geratener Zeitpunkte. */
    if (window.ResizeObserver && g) {
      beobachter = new ResizeObserver(function () { requestAnimationFrame(hin); });
      beobachter.observe(g);
    }
    window.addEventListener('load', hin, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(hin);

    // Dokumentierte Obergrenze - kein unbegrenztes Nachfuehren (Punkt 6).
    setTimeout(function () { if (aktiv) beenden(); }, HALTEZEIT);
  };

  /* ---- Aus dem Vor-/Zurueck-Speicher (bfcache) ------------------------------ */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    const stand = lesen();
    if (!stand || !stand.anker) return;
    // Erst nach den eigenen pageshow-Arbeiten anderer Skripte (Kopfzeile, Titel) messen.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        const y = zielY(stand);
        if (Math.abs(window.scrollY - y) > 30) window.scrollTo(0, y);
      });
    });
  });

  /* Welcher der beiden Wege gilt, entscheidet die Adresse:
       ?page=N  -> Seite N steht schon da, nur die Seiten darueber fehlen (vorseitenHolen)
       ohne page -> der alte Weg, der alles nachlaedt (wiederherstellen) */
  const losgehen = () => {
    const seite = seiteAusAdresse();
    if (seite) { vorseitenHolen(seite); return; }
    wiederherstellen();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', losgehen);
  } else {
    losgehen();
  }
})();


/* STILLGELEGT (14.09.2026) - bisherige Fassung, ersetzt durch den Block oben.
   Kommentar-Enden darin sind als '* /' entschaerft.

/* ============================================================================
   Zurueck-Knopf auf der Produktseite + gemerkte Scrollposition der Listenseite
   ----------------------------------------------------------------------------
   Zwei Dinge, die zusammengehoeren: Der Weg zurueck soll dort landen, wo man
   losgegangen ist - egal ob ueber den Knopf auf der Seite oder ueber die
   Zurueck-Funktion des Browsers.

   Warum das nicht von allein funktioniert: Die Listenseite laedt weitere
   Produkte per "Mehr laden" nach, OHNE dass sich die Adresse aendert
   (assets/load-more.js haengt die Kacheln einfach an). Kommt man zurueck, baut
   der Browser die Seite in ihrem URSPRUENGLICHEN Zustand wieder auf - also nur
   mit der ersten Portion. Die Seite ist dann viel kuerzer als vorher, und die
   gemerkte Scrollposition liegt hinter ihrem Ende. Der Browser scrollt so weit
   er kann und gibt auf; man landet irgendwo im Nirgendwo oder ganz unten.

   Deshalb wird nicht nur die Position gemerkt, sondern auch WIE VIELE Kacheln
   geladen waren. Beim Zurueckkommen werden die fehlenden Portionen zuerst
   nachgeholt, und erst dann wird gescrollt.

   Der Sonderfall bfcache braucht nichts davon: Legt der Browser die Seite
   samt DOM in den Vor-/Zurueck-Speicher, sind die nachgeladenen Kacheln noch
   da und er stellt die Position selbst wieder her. Das erkennt man daran, dass
   die Navigationsart dann NICHT 'back_forward' mit frischem Aufbau ist, sondern
   ein pageshow mit persisted = true - dort greifen wir gar nicht ein.
   ========================================================================== * /
(function () {
  'use strict';

  const VORSATZ = 'dgl:pos:';
  const HALTBARKEIT = 60 * 60 * 1000; // eine Stunde

  const schluessel = () => VORSATZ + location.pathname + location.search;
  const gitter = () => document.querySelector('#product-grid');

  const lesen = () => {
    try {
      return JSON.parse(sessionStorage.getItem(schluessel()) || 'null');
    } catch (e) {
      return null;
    }
  };

  const istZurueckNavigation = () => {
    try {
      const eintrag = performance.getEntriesByType('navigation')[0];
      return !!eintrag && eintrag.type === 'back_forward';
    } catch (e) {
      return false;
    }
  };

  /* ---- Scrollwiederherstellung des Browsers fruehzeitig abschalten ----------
     Muss VOR dem ersten Bild passieren, sonst springt die Seite erst an eine
     falsche Stelle und danach an die richtige. Nur abschalten, wenn wirklich
     etwas wiederherzustellen ist - sonst nimmt man dem Browser sein normales
     Verhalten weg, ohne einen Ersatz zu haben. * /
  const gemerkt = lesen();
  const zustaendig = istZurueckNavigation() && gemerkt && gemerkt.y > 0
    && (Date.now() - gemerkt.zeit) < HALTBARKEIT;
  if (zustaendig && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  /* ---- Merken ------------------------------------------------------------- * /
  const merken = () => {
    const g = gitter();
    if (!g) return;
    try {
      sessionStorage.setItem(schluessel(), JSON.stringify({
        y: Math.round(window.scrollY),
        kacheln: g.querySelectorAll('.grid__item').length,
        zeit: Date.now()
      }));
    } catch (e) {
      /* privater Modus o.ae. - dann eben ohne Gedaechtnis * /
    }
  };

  // pagehide deckt alles ab: Navigation, Tab schliessen, Wechsel in den bfcache.
  // Zuverlaessiger als beforeunload, das auf iOS haeufig gar nicht feuert.
  window.addEventListener('pagehide', merken);
  // Zusaetzlich beim Klick auf einen Link, in der Erfassungsphase: Damit die
  // Position auch dann steht, wenn die Navigation ueber JS laeuft und pagehide
  // erst nach einer Layoutaenderung kaeme.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href]')) merken();
  }, true);

  /* ---- Zurueck-Knopf der Produktseite -------------------------------------
     Der Knopf ist ein echter Link auf die Kollektion (bzw. den Shop). Das ist
     der Fallzustand: Wer die Seite direkt oeffnet - aus einer Suchmaschine,
     einem geteilten Link, einem neuen Tab - hat keine Vorgeschichte, in die
     man zurueckgehen koennte, und landet sinnvoll im Shop.
     Gibt es dagegen eine eigene Vorgeschichte, wird daraus ein echtes
     Zurueck. Nur so greift die Wiederherstellung oben: Sie haengt an der
     Navigationsart 'back_forward', und die entsteht nur bei history.back(),
     nicht bei einem normalen Seitenaufruf. * /
  document.addEventListener('click', function (e) {
    const knopf = e.target.closest && e.target.closest('[data-product-back]');
    if (!knopf) return;
    let vonHier = false;
    try {
      vonHier = !!document.referrer &&
        new URL(document.referrer).origin === location.origin;
    } catch (err) {
      vonHier = false;
    }
    if (vonHier && history.length > 1) {
      e.preventDefault();
      history.back();
    }
  });

  /* ---- Wiederherstellen --------------------------------------------------- * /
  const nachladen = async (g, ziel) => {
    // Obergrenze gegen Endlosschleifen, falls der Knopf einmal auf sich selbst
    // zeigt. 30 Portionen sind mehr als jede Kollektion hier hat.
    let schutz = 30;
    while (g.querySelectorAll('.grid__item').length < ziel && schutz-- > 0) {
      const knopf = document.querySelector('.collection-load-more');
      const naechste = knopf && knopf.dataset.nextUrl;
      if (!naechste) return;
      let doc;
      try {
        const antwort = await fetch(naechste);
        doc = new DOMParser().parseFromString(await antwort.text(), 'text/html');
      } catch (e) {
        return;
      }
      const neu = doc.querySelector('#product-grid');
      if (!neu) return;
      neu.querySelectorAll('.grid__item').forEach(function (el) { g.appendChild(el); });
      const neuerKnopf = doc.querySelector('.collection-load-more');
      if (neuerKnopf && neuerKnopf.dataset.nextUrl) {
        knopf.dataset.nextUrl = neuerKnopf.dataset.nextUrl;
      } else {
        knopf.style.display = 'none';
        return;
      }
    }
  };

  const wiederherstellen = async () => {
    if (!zustaendig) return;
    const g = gitter();
    if (!g) return;

    await nachladen(g, gemerkt.kacheln || 0);

    // Mehrfach anspringen statt einmal: Produktbilder haben zwar feste
    // Seitenverhaeltnisse, aber Schriften und nachgeladene Abschnitte
    // veraendern die Hoehe noch ein paar Bilder lang. Ein einziger Sprung
    // landet dann daneben.
    const hin = function () { window.scrollTo(0, gemerkt.y); };
    hin();
    requestAnimationFrame(hin);
    setTimeout(hin, 150);
    setTimeout(hin, 500);
    setTimeout(function () {
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    }, 900);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wiederherstellen);
  } else {
    wiederherstellen();
  }
})();

Ende STILLGELEGT */
